import React, { createElement, memo } from 'react'

import { useTranslation } from 'react-i18next'

import { TranslateProps } from '../../../ana-toolbox'

/*
 * We are using this component to wrap the translations into a HTML
 * element containing the translation key as data attribute, this can
 * be helpful when trying to find a key for a translation using the
 * developer tools.
 */

export const Translate = memo(
  ({ component = 'span', className, children, options, fallback, dangerous, ...props }: TranslateProps) => {
    const { t } = useTranslation()

    if (typeof children === 'undefined') return null
    if (typeof children !== 'string') return <>{children}</>

    if (dangerous) {
      return createElement(component, {
        className,
        'data-translation-key': children,
        dangerouslySetInnerHTML: {
          __html: t(children, {
            ...options,
            ...props,
            defaultValue: fallback,
          }),
        },
      })
    }

    return createElement(
      component,
      {
        className,
        'data-translation-key': children,
      },
      <>
        {t(children, {
          ...options,
          ...props,
          defaultValue: fallback,
        })}
      </>
    )
  }
)

Translate.displayName = 'Translate'
